import { Config } from '@ddt-web/store-service';
import { UserPreferences } from '@ddt-web/user-data';

import { AppTypedStoreConfig } from '../models/typed-store-config';

export class UserPreferencesConfig extends AppTypedStoreConfig {
	public static userPreferences = { name: 'userPreferences', storeAsList: false, defaultValue: null, portfolioIndependent: true } as Config<UserPreferences>;
}
